import { Router, ActivatedRoute, Params } from "@angular/router";
import { inject, Injectable } from "@angular/core";
import { MatDialogConfig, MatDialogRef, MatDialog } from "@angular/material/dialog";
import { ComponentType } from "@angular/cdk/portal";
import { EMPTY, firstValueFrom, map, Observable, tap } from "rxjs";

import { hasValue } from "@my-aon/utils";
import { AuthenticationService } from "@my-aon/auth";
import { DialogConfirmComponent } from "../../components";

@Injectable({
    providedIn: 'root'
})
export abstract class DialogService {

    readonly dialog: MatDialog = inject(MatDialog);
    readonly router: Router = inject(Router);
    readonly route: ActivatedRoute = inject(ActivatedRoute);
    readonly auth: AuthenticationService = inject(AuthenticationService);

    /**
     * @deprecated don't use this, dialog-config globally defined
     */
    protected dialogConfig: MatDialogConfig = {
    }

    dialogRef: MatDialogRef<any> | undefined;


    hasAnyDialogOpen = (): boolean => hasValue(this.dialogRef);

    ngOnDestroy(): void {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.dialogRef?.close();
    }

    setupNavigation(commands: any[], queryParams?: Params) {
        this.router.navigate(commands, { queryParams, relativeTo: null, queryParamsHandling: 'merge' });
    }

    /**
     * @TODO
     * @param component
     * @param data
     * @returns
     */
    open<T, D = any>(component: ComponentType<T>, data: D) {

        return this.dialog.open(component, { data });
    }

    private _confirmDialog: true | null = null;
    confirm<D = any>({ title, message }: { title: string, message: string }, data?: D | null): Observable<boolean> {

        if (this._confirmDialog)
            return EMPTY;

        this._confirmDialog = true;

        this.dialogRef = this.dialog.open(DialogConfirmComponent, {
            /* position: {
                left: '0',
                bottom: '0'
            }, */
            position: undefined,
            minWidth: 500,
            minHeight: 250,
            width: '25vw',
            height: '25vh',
            hasBackdrop: true,
            data: { title, message, data }
        });

        return this.dialogRef.afterClosed()
            .pipe(map(result => result === true))
            .pipe(tap(() => {
                this._confirmDialog = null;
            }));
    }

    confirmAsync = async <D = any>({ title, message }: { title: string, message: string }, data?: D | null) => await firstValueFrom(this.confirm<D>({ title, message }, data));
}
